import { render, staticRenderFns } from "./PriceIndication.vue?vue&type=template&id=60e98e78"
import script from "./PriceIndication.vue?vue&type=script&lang=js"
export * from "./PriceIndication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports